 
 
<template> 
    <iframe :src="nav"  scrolling="no"  style="width: 100%;height:100%;margin-top:-20px;overflow-y:auto" frameborder="0" ></iframe>
    
</template>
 
<script>
import {goNav} from '../../api/webSiteConfig';
   export default {

    data() {
        return {  
            nav:"",
        };
    },
     //页面加载方法
    mounted() { 
        this.getData();    
    },
    methods: { 
        getData(){
            let data = {};
            goNav(data).then(res => {  
                if(res.code=='200'){ 
                    this.nav = res.data.nav;   
                }else{
                    that.$message.error(res.message);   
                }
            });
        }
    }
   }
   
</script>
 
<style lang="scss" scoped>
 
</style>